// Breadcrumb de la vista de detalle de billetera: configura el rastro de navegación con icono y número de billetera.
import { faWallet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { WalletDetail } from '../../models/Wallet';

interface WalletBreadcrumbProps {
  walletId: number;
  walletDetail?: WalletDetail | null;
}

export const WalletBreadcrumb = ({ walletId, walletDetail }: WalletBreadcrumbProps) => {
  const { t } = useTranslation('walletsModule');
  const { getTeamType } = usePermissions();
  const teamType = getTeamType();
  const isExternal = teamType === 'tenant_external';

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [
      {
        label: isExternal ? t('breadcrumbs.wallet') : t('breadcrumbs.wallets'),
        path: '/wallets',
      },
    ];

    const clientName = walletDetail?.team?.name;
    const walletLabel = clientName || `#${walletId}`;

    items.push({
      label: (
        <span className="inline-flex items-center gap-2 text-sm text-text">
          <FontAwesomeIcon icon={faWallet} className="w-3.5 h-3.5 text-icons" />
          <span className="text-title">{walletLabel}</span>
        </span>
      ),
      title: walletLabel, // Título para el documento
    });

    return items;
  }, [t, walletDetail, walletId, isExternal]);

  usePageNavigation({ breadcrumbs });

  return null;
};
